<template>
  <div class="loading">
    <img src="./loading.gif">
    <p class="desc">{{title}}</p>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    props: {
      title: {
        type: String,
        default: '正在载入...'
      }
    }
  };
</script>
<style scoped lang="scss">
  @import "~common/scss/variable";

  .loading {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      background: url('./loading.gif') center center no-repeat #fff;
      width: 100%;
      height: 100%;
      z-index: 1000;
    img {
      width: 0.48rem;
      height: 0.48rem;
    }

    .desc {
      line-height: 0.4rem;
      font-size: $font-size-small;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/loading/loading.vue